import { modifyTaxPayerFields, getTaxPayerData } from "../../../../../../../../../store/Users/actions";
import { validateCuit, validateMail, inputFilled } from "../../../../functions";

export const getPayerData = (items, dupData) => {
  return [
    {
      text: "(*) CUIT/CUIL",
      name: "cuit",
      value: items?.cuit,
      onBlur: getTaxPayerData,
      onChange: modifyTaxPayerFields,
      checked: validateCuit(items?.cuit),
      disabled: dupData,
      errorMessage: validateCuit(items?.cuit) ? "" : "Error Cuit/Cuil inválido",
    },
    {
      text: "(*) Apellido Nombre / Razón Social",
      name: "name",
      value: items?.name,
      onChange: modifyTaxPayerFields,
      checked: inputFilled(items?.name),
      disabled: dupData,
      errorMessage: inputFilled(items?.name) ? "" : "Este campo no puede estar vacío",
    },
    {
      text: "(*) Mail",
      name: "mail",
      value: items?.mail,
      onChange: modifyTaxPayerFields,
      checked: validateMail(items?.mail),
      errorMessage: validateMail(items?.mail) ? "" : "Error Email inválido",
    },
  ];
};
